/**
 * Hằng số dùng chung cho các màn Cấu hình bữa ăn (meal config).
 * Khớp với enum phía backend (api/meal-slot, api/meal-group-config).
 */
export const TIME_OF_DAY_OPTIONS = [
  { value: 'morning', text: 'Sáng' },
  { value: 'lunch', text: 'Trưa' },
  { value: 'afternoon', text: 'Chiều' },
  { value: 'evening', text: 'Tối' }
]

// Lựa chọn khoảng (range) — dùng cho radio "Phục vụ"
export const SERVE_RANGE_OPTIONS = [
  { value: 'mon-fri', text: 'Thứ 2 - Thứ 6' },
  { value: 'mon-sat', text: 'Thứ 2 - Thứ 7' },
  { value: 'specific', text: 'Một ngày cụ thể' }
]

// Các thứ cụ thể trong tuần
export const WEEKDAY_OPTIONS = [
  { value: 'mon', text: 'Thứ 2' },
  { value: 'tue', text: 'Thứ 3' },
  { value: 'wed', text: 'Thứ 4' },
  { value: 'thu', text: 'Thứ 5' },
  { value: 'fri', text: 'Thứ 6' },
  { value: 'sat', text: 'Thứ 7' }
]

// Tất cả giá trị serveDays (range + weekday) — để hiển thị nhãn
export const SERVE_DAYS_OPTIONS = [
  { value: 'mon-fri', text: 'Thứ 2 - Thứ 6' },
  { value: 'mon-sat', text: 'Thứ 2 - Thứ 7' },
  ...WEEKDAY_OPTIONS
]

// Cấu hình thời gian đăng ký (per áp dụng) — bữa cố định
export const REGISTER_OPEN_BEFORE_OPTIONS = [
  { value: '14d', text: 'Trước 2 tuần (14 ngày)' },
  { value: '7d', text: 'Trước 1 tuần (7 ngày)' }
]
export const REGISTER_CLOSE_BEFORE_OPTIONS = [
  { value: '7d', text: 'Trước 1 tuần (7 ngày)' },
  { value: '1d', text: 'Trước 1 ngày (21h hôm trước)' }
]
export const CANCEL_BEFORE_OPTIONS = [
  { value: '1d', text: 'Trước 1 ngày (21h hôm trước)' },
  { value: 'sameday', text: 'Cùng ngày (8h sáng)' }
]

export const FEE_TYPE_OPTIONS = [
  { value: 'paid', text: 'Có thu phí' },
  { value: 'free', text: 'Miễn phí' }
]

export const MEAL_TYPE_LABEL = { fixed: 'Cố định', supplementary: 'Bổ sung' }

// Nhãn loại bữa dạng đầy đủ ("Bữa ăn cố định"…) — khác MEAL_TYPE_LABEL (chỉ "Cố định")
export const MEAL_TYPE_FULL_LABEL = { fixed: 'Bữa ăn cố định', supplementary: 'Bữa ăn bổ sung' }
export const mealTypeFullLabel = v => MEAL_TYPE_FULL_LABEL[v] || ''

// CÓ/KHÔNG đăng ký (isDefaultRegister)
export const DEFAULT_REGISTER_LABEL = { true: 'CÓ đăng ký', false: 'KHÔNG đăng ký' }
export const defaultRegisterLabel = v => (v ? DEFAULT_REGISTER_LABEL.true : DEFAULT_REGISTER_LABEL.false)
export const defaultRegisterColor = v => (v ? 'green' : 'grey')

// Phân loại nhóm (category)
export const GROUP_CATEGORY_OPTIONS = [
  { value: 'default', text: 'Mặc định' },
  { value: 'custom', text: 'Tùy chỉnh' }
]

// defaultType của nhóm mặc định
export const DEFAULT_TYPE_LABEL = { all: 'Toàn trường', level: 'Cấp học', grade: 'Khối', class: 'Lớp' }

// Lịch sử thao tác (label + màu + icon đi cùng nhau)
export const LOG_ACTION_META = {
  create: { label: 'Tạo mới', color: 'green', icon: 'mdi-plus' },
  update: { label: 'Sửa', color: 'orange', icon: 'mdi-pencil' },
  delete: { label: 'Đã xóa', color: 'red', icon: 'mdi-delete' }
}

// Chuỗi fallback / dùng lại nhiều nơi
export const EMPTY_LABEL = '-'
export const NO_END_DATE_LABEL = 'Chưa xác định' // toDate trống
export const SERVE_BY_MEAL_LABEL = 'Theo bữa' // serveDays trống ở áp dụng
export const YES_LABEL = 'Có'
export const NO_LABEL = 'Không'
export const AUTO_REGISTER_LABEL = 'Tự động đăng ký' // nhãn cụm radio isDefaultRegister
export const DEFAULT_SLOT_TITLE = 'Bữa trưa bán trú' // tên bữa mặc định (seed) — dùng làm slot mặc định
export const EFFECT_NOTE = 'Cấu hình có hiệu lực cho lịch ăn tính từ ngày tiếp theo '

const toLabel = options => value => {
  const found = options.find(o => o.value === value)
  return found ? found.text : value
}

export const groupCategoryLabel = toLabel(GROUP_CATEGORY_OPTIONS)
export const defaultTypeLabel = v => DEFAULT_TYPE_LABEL[v] || EMPTY_LABEL

export const timeOfDayLabel = toLabel(TIME_OF_DAY_OPTIONS)
export const serveDaysLabel = toLabel(SERVE_DAYS_OPTIONS)
export const feeTypeLabel = toLabel(FEE_TYPE_OPTIONS)
export const registerOpenBeforeLabel = toLabel(REGISTER_OPEN_BEFORE_OPTIONS)
export const registerCloseBeforeLabel = toLabel(REGISTER_CLOSE_BEFORE_OPTIONS)
export const cancelBeforeLabel = toLabel(CANCEL_BEFORE_OPTIONS)

// serveDays là weekday cụ thể nếu không phải range
export const isWeekday = v => v && v !== 'mon-fri' && v !== 'mon-sat'
